<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content confirm">
        <div class="hTitle">
          <h1>入力内容のご確認をお願いします。</h1>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              お名前
            </p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.username }}</p>
            <Alert v-if="error.username">
              {{ error.username }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              フリガナ
            </p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.userkana }}</p>
            <Alert v-if="error.userkana">
              {{ error.userkana }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>企業名</p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.company }}</p>
            <Alert v-if="error.company">
              {{ error.company }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              電話番号
            </p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.tel }}</p>
            <Alert v-if="error.tel">
              {{ error.tel }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              メールアドレス
            </p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.email }}</p>
            <Alert v-if="error.email">
              {{ error.email }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              パスワード
            </p>
          </div>
          <div class="form c-alertPos">
            <div class="c-password">
              <p class="c-password__input">
                {{ params.password | maskedPassword(isVisiblePassword) }}
              </p>
              <ButtonEye class="c-password__toggle" @click="togglePassword" />
            </div>
            <Alert v-if="error.password">
              {{ error.password }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>代理店コード</p>
          </div>
          <div class="form c-alertPos">
            <p>{{ params.agentCode }}</p>
          </div>
        </div>
        <div class="checkArea">
          <div class="form">
            <Checkbox id="terms" name="terms" v-model="params.terms">
              <div class="c-alertPos">
                <a
                  :href="$constants.serviceSiteUrl + '/terms/'"
                  target="_blank"
                  class="c-link--blank"
                >
                  利用規約
                </a>
                に同意する。
                <Alert v-if="isEdited.terms && error.terms">
                  {{ error.terms }}
                </Alert>
              </div>
            </Checkbox>
          </div>
          <div class="form">
            <Checkbox id="privacy" name="privacy" v-model="params.privacy">
              <div class="c-alertPos">
                <a
                  :href="$constants.serviceSiteUrl + '/privacy/'"
                  target="_blank"
                  class="c-link--blank"
                >
                  個人情報の取り扱い
                </a>
                に同意する。
                <Alert v-if="isEdited.privacy && error.privacy">
                  {{ error.privacy }}
                </Alert>
              </div>
            </Checkbox>
          </div>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              size="w260"
              variant="border"
              icon="return_gn"
              fsize="f16"
              @click="gotoInput"
            >
              内容を修正する
            </Button>
          </div>
          <div class="form-auto">
            <Button
              size="w260"
              variant="main"
              fsize="f16"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isError || isProcessing"
              @click="register"
            >
              会員登録する
            </Button>
          </div>
        </div>
        <Alert v-if="errorResponse" class="l-mt-3">
          {{ errorResponse }}
        </Alert>
      </div>
    </div>
  </main>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import ButtonEye from '@/components/ButtonEye';
import Checkbox from '@/components/Checkbox';
import TitleRegister from '@/components/TitleRegister';
import utils from '@/utils';
import Validation from '@/validation';
import Progress from '@/components/Progress';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
export default {
  props: {
    agentCode: {
      type: String,
      required: false
    }
  },

  components: {
    Alert,
    Button,
    ButtonEye,
    Checkbox,
    TitleRegister,
    Progress
  },

  data() {
    // クエリパラメーターで代理店コードが指定されている場合は、初期パラメーターを更新
    const initParams = Object.assign({}, this.$store.state.register.params);
    if (this.agentCode) {
      initParams.agentCode = this.agentCode;
    }

    return {
      error: {
        company: '',
        email: '',
        password: '',
        tel: '',
        userkana: '',
        username: '',
        privacy: '',
        terms: ''
      },
      errorResponse: '',
      progress: [
        {
          label: '内容入力'
        },
        {
          current: true,
          label: '内容確認'
        },
        {
          label: '登録完了'
        }
      ],
      params: initParams,
      isEdited: Object.assign({}, this.$store.state.register.isEdited),
      isError: false,
      isProcessing: false,
      isVisiblePassword: false
    };
  },

  computed: {
    isTrial() {
      return this.$route.name === 'registerTrialConfirm';
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    'params.privacy': {
      handler(value, oldValue) {
        this.error.privacy = new Validation().check().test(this.params.privacy);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.privacy = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.terms': {
      handler(value, oldValue) {
        this.error.terms = new Validation().check().test(this.params.terms);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.terms = true;
          this.updateParams();
        }
      },
      immediate: true
    }
  },

  created() {
    this.validation();

    for (let key in this.error) {
      if (key === 'privacy' || key === 'terms') {
        continue;
      }
      if (this.error[key]) {
        this.gotoInput();
        break;
      }
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    register() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      this.auth
        .signup(this.params, this.isTrial)
        .then(response => {
          this.$store.dispatch('register/reset');
          this.$store.dispatch('register/setStatus', {
            provisional: true
          });
          this.$router.push({ name: 'registerProvisional' });
        })
        .catch(error => {
          // 代理店コードが入力されていないのに代理店コード用のエラーキーが返ってきた時はotherに変換
          if (
            this.params.agentCode == '' &&
            error.code == 'extensibility_error'
          ) {
            error.code = 'other';
          }

          this.isProcessing = false;
          this.errorResponse = ERROR_MESSAGE.auth0[error.code]
            ? ERROR_MESSAGE.auth0[error.code]
            : ERROR_MESSAGE.other;
        });
    },

    gotoInput() {
      const routeName = this.isTrial ? 'registerTrial' : 'register';

      if (this.agentCode) {
        this.$router.push({
          name: routeName,
          query: {
            agentCode: this.agentCode
          }
        });
      } else {
        this.$router.push({ name: routeName });
      }
    },

    togglePassword(isVisible) {
      this.isVisiblePassword = isVisible;
    },

    updateParams() {
      this.$store.dispatch('register/setParams', this.params);
      this.$store.dispatch('register/setEdited', this.isEdited);
    },

    validation() {
      this.error.email = new Validation()
        .input()
        .email()
        .test(this.params.email);
      this.error.password = new Validation()
        .input()
        .password()
        .test(this.params.password);
      this.error.tel = new Validation()
        .input()
        .tel()
        .test(this.params.tel);
      this.error.userkana = new Validation()
        .input()
        .kana()
        .test(this.params.userkana);
      this.error.username = new Validation().input().test(this.params.username);
    }
  }
};
</script>
